import { useAuth } from '@/context/AuthContext';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({
  children,
  adminOnly = false,
}: {
  children: React.ReactNode;
  adminOnly?: boolean;
}) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/" />;
  }

  if (adminOnly && !user.isAdmin) {
    return <Navigate to="/send-event" />;
  }

  // Autorizado
  return <>{children}</>;
};

export default ProtectedRoute;
